// Returns the category header
export const CategoryNavigationService_GetNavigationHeaderLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryNavigationService_GetNavigationHeader
  );
CategoryNavigationService_GetNavigationHeaderLazy.method =
  "aysa_api.services.category_page.v1.navigation.CategoryNavigationService/GetNavigationHeader" as const;

// Returns a category tree navigation
export const CategoryNavigationService_GetTreeNavigationLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryNavigationService_GetTreeNavigation
  );
CategoryNavigationService_GetTreeNavigationLazy.method =
  "aysa_api.services.category_page.v1.navigation.CategoryNavigationService/GetTreeNavigation" as const;

// Returns all the information required to display the BAS or other banners in category header and provide tracking.
export const CategoryNavigationService_GetHeaderBannerLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryNavigationService_GetHeaderBanner
  );
CategoryNavigationService_GetHeaderBannerLazy.method =
  "aysa_api.services.category_page.v1.navigation.CategoryNavigationService/GetHeaderBanner" as const;

// GetNavigation returns the navigation section: categories label and popular filters (for App and mWeb)
export const CategoryNavigationService_GetNavigationLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryNavigationService_GetNavigation
  );
CategoryNavigationService_GetNavigationLazy.method =
  "aysa_api.services.category_page.v1.navigation.CategoryNavigationService/GetNavigation" as const;

// GetNavigationSectionCategories returns category tree navigation (for App and mWeb)
export const CategoryNavigationService_GetNavigationSectionCategoriesLazy =
  () =>
    import("./service.grpc").then(
      (m) => m.CategoryNavigationService_GetNavigationSectionCategories
    );
CategoryNavigationService_GetNavigationSectionCategoriesLazy.method =
  "aysa_api.services.category_page.v1.navigation.CategoryNavigationService/GetNavigationSectionCategories" as const;
